import Vue from 'vue';

export const cr3000 = {
  target: null,
  create: function (params) {
    import('./layout').then(res => {
      const CR3000 = Vue.extend(res.default);
      this.target = new CR3000({ propsData: { width: 400, params } });
      this.target.costomMount();
    });
  },
  remove: function () {
    this.target && this.target.unMount();
  }
};

export const cr2500 = {
  target: null,
  create: function (params) {
    import('./layout').then(res => {
      const CR2500 = Vue.extend(res.default);
      this.target = new CR2500({ propsData: { width: 400, params } });
      this.target.costomMount();
    });
  },
  remove: function () {
    this.target && this.target.unMount();
  }
};
